var router = [{
  id: 1,
  name: "产品管理",
  path: "",
  children: [{
    id: 2,
    name: "产品导航",
    path: "/productVavigation/indexInterview"
  }, {
    id: 3,
    name: "环境管理",
    path: "/productVavigation/environmentManagement"
  }]
}];
export default router;